<template>
    <el-dialog
        :visible="showModal"
        :show-close="false"
        :before-close="handleClose"
        custom-class="download-modal-new"
        :width="isMobile ? '85vw' : '540px'"
        :close-on-click-modal="false"
        :modal-append-to-body="true"
    >
        <div class="custom-modal-content">
            <div class="close-btn" @click="handleClose">&times;</div>
            <div class="modal-label">
                <img src="@/assets/images/modal_tag.svg" alt="tag" class="modal-tag">
                EXCLUSIVELY ON ALL EAT APP
            </div>
            <div class="modal-title">
                Unlock <span class="green">{{currencySign}}{{currencySign=='￡'?'6':'10'}}</span> OFF Your Next Orders!
            </div>
            <div class="modal-subtitle">
                Delicious savings await you in partnership with ALL EAT.
            </div>
            <div class="code-box">
                <span class="code-label">Your Code:</span>
                <span class="code-value">{{currencySign=='￡'?'ALLEAT':'ALLEATIE'}}</span>
            </div>
            <div class="modal-desc" v-if="currencySign=='￡'">
                Get <span class="black">￡2 off</span> each of your first 3 orders.
            </div>
            <div class="modal-desc" v-else>
                Get <span class="black">€2 off</span> your first order, and <span class="black">€4 off</span> each of your next two orders
            </div>
            <button class="download-btn" @click="downloadApp">Download Now</button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "DownloadAppModal",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            seconds: {
                type: Number,
                default: 3000
            },
            currency: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                showModal: false,
                showDownloadModal: false
            }
        },
        computed: {
            currencySign() {
                return this.currency || (this.$isUk ? '￡' : '€');
            },
            isMobile() {
                return window.innerWidth < 700;
            }
        },
        watch: {
            value(newVal) {
                this.showModal = newVal;
            }
        },
        mounted() {
            this.getAppConfig();
            if(window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isSsg) {
                // ssg渲染中
            } else {
                setTimeout(() => {
                    this.$emit('input', this.showDownloadModal);
                }, this.seconds);
            }
        },
        methods: {
            getAppConfig() {
                fetch('https://alleatapp.com/maps/js/appConfig.json')
                .then(res=>{
                    return res.json()
                })
                .then(res=>{
                    console.log(res.showDownloadApp,'showDownloadApp 配置信息')
                    this.showDownloadModal = Boolean(res.showDownloadApp)
                })
                .catch(err=>{
                    console.log(err,'err')
                })
            },
            handleClose() {
                this.$emit('input', false);
                this.showModal = false;
            },
            downloadApp() {
                const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    window.open('http://itunes.apple.com/cn/app/id1603420846?mt=8', '_blank');
                } else {
                    window.open('https://play.google.com/store/apps/details?id=io.dcloud.uniAllEat', '_blank');
                }
            }
        }
    }
</script>

<style scoped lang="scss">
/* 覆盖 el-dialog 样式 */
:deep(.download-modal-new) {
    border-radius: 14px;
    box-shadow: 0 6px 24px rgba(0,0,0,0.16);
    padding: 0;
    background: #fff;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
}
.custom-modal-content {
    position: relative;
    text-align: center;
    padding: 32px 28px 26px 28px;
    border-radius: 14px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    word-break: normal;
}
.close-btn {
    position: absolute;
    top: 18px;
    right: 22px;
    font-size: 26px;
    color: #222;
    cursor: pointer;
    font-weight: bold;
    z-index: 10;
}
.modal-label {
    background: #ffe97a;
    color: #a67c00;
    font-weight: bold;
    font-size: 15px;
    border-radius: 16px;
    padding: 3.5px 14px;
    margin-bottom: 22px;
    letter-spacing: 0.5px;
    .modal-tag {
        height: 20px;
        width: 20px;
    }
}
.modal-title {
    font-size: 32px;
    font-weight: bolder;
    margin-bottom: 10px;
    color: #181c32;
    line-height: 1.1;
    word-break: normal;
}
.green {
    color: #19e381;
}
.black  {
    color: #000;
    font-weight: bold;
}
.modal-subtitle {
    color: #64748b;
    font-size: 16px;
    margin-bottom: 22px;
    font-weight: 400;
}
.code-box {
    border: 2px dashed #19e381;
    background: #f6fff9;
    border-radius: 10px;
    padding: 13px 0 9px 0;
    margin: 0 auto 16px auto;
    max-width: 270px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: nowrap;
    user-select: text;
}
.code-label {
    color: #3a4a5d;
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 3px;
}
.code-value {
    color: #19e381;
    font-size: 24px;
    font-weight: 800;
    letter-spacing: 1.2px;
}
.modal-desc {
    color: #64748b;
    font-size: 14px;
    margin-bottom: 22px;
    margin-top: -5px;
    padding: 0 12px;
}
.download-btn {
    background: #19e381;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    border: none;
    border-radius: 9px;
    padding: 13px 0;
    width: 100%;
    max-width: 220px;
    cursor: pointer;
    margin-top: 8px;
    transition: background 0.2s;
}
.download-btn:hover {
    background: #13c46b;
}
@media (max-width: 600px) {
    .custom-modal-content {
        padding: 6vw 0 6vw 0;
        max-width: 84vw;
    }
    .modal-label {
        font-size: 12.8px;
        padding: 3.2px 14.4px;
        margin-bottom: 22.4px;
    }
    .modal-title {
        font-size: 22.4px;
        margin-bottom: 9.6px;
        padding: 0 12px;
        font-weight: bolder;
    }
    .modal-subtitle {
        font-size: 12.8px;
        margin-bottom: 25.6px;
    }
    .code-box {
        padding: 14.4px 0 9.6px 0;
        margin-bottom: 19.2px;
        max-width: 272px;
        border-radius: 9.6px;
        flex-direction: column;
        gap: 0;
    }
    .code-label {
        font-size: 17.6px;
        margin-bottom: 4.8px;
    }
    .code-value {
        font-size: 30.4px;
        letter-spacing: 1.6px;
    }
    .modal-desc {
        font-size: 14.4px;
        margin-bottom: 25.6px;
        margin-top: -6.4px;
    }
    .download-btn {
        font-size: 14.4px;
        padding: 9.6px 0;
        max-width: 272px;
        border-radius: 8px;
    }
    .close-btn {
        top: 19.2px;
        right: 22.4px;
        font-size: 25.6px;
    }
}
</style>

